import { css } from 'linaria';

export default function loadCss() {
  return css`
    :global(html) {
      @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;700&display=swap');
    }
  `;
}
